import moment from "moment";
import { StartProjectTableAction } from "../enums";

export class StartProjectLogResult {
    public id: number = 0;
    public startProjectTableAction: StartProjectTableAction = StartProjectTableAction.Create;
    public dateTime: moment.Moment = moment(moment.now(), 'YYYY-MM-DD').utc(false);
    public employeeId: number = 0;
    public fullName: string = '';
}
